import type { EnnismoreTheme } from '@/ui/theme';

import { orientExpressTheme } from './orientexpress.theme';

export const orientExpressRomeTheme: EnnismoreTheme = {
  ...orientExpressTheme,
  logoUrl: '/brands/orientexpress/images/logo-rome.png',
  componentProperties: {
    ...orientExpressTheme.componentProperties,
    footer: {
      ...orientExpressTheme.componentProperties.footer,
      emblemUrl: '/brands/orientexpress/images/footer-seal-rome.svg',
    },
  },
};
